// eslint-disable-next-line
export default (CURRENT_ENV, country) => ({
  config: 'sga',
});
